import { Component } from '@angular/core';
import { WiperLoadingComponent } from '../../wiper-loading/wiper-loading.component';
import { HeadWiperComponent } from './head-wiper/head-wiper.component';
@Component({
  selector: 'app-table-loading-skeleton',
  imports: [WiperLoadingComponent, HeadWiperComponent],
  templateUrl: './table-loading-skeleton.component.html',
  styleUrl: './table-loading-skeleton.component.scss',
})
export class TableLoadingSkeletonComponent {}
